import React, { useState } from "react";
import { Formik, Form } from "formik";
import { useLocation } from "react-router-dom";
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';
import FormSelect from '../user_management/FormSelect'; // Assuming FormSelect is in the same directory
import { PendingApprovalAPI } from "../../axios";
import ImageComponent from "./ImageComponent";
import AnnotatedImage from './AnnotatedImage';
import { AuthAPI } from "../../axios";

const PendingApprovalView = () => {
  const wasteTypes = [
    "Spent solvents",
    "Acid, alkaline or saline wastes",
    "Used oils",
    "Spent chemical catalysts",
    "Chemical preparation wastes",
    "Chemical deposits and residues",
    "Industrial effluent sludges",
    "Sludges and liquid wastes from waste treatment",
    "Health care and biological wastes",
    "Metal waste, ferrous",
    "Metal waste, non-ferrous",
    "Metal wastes, mixed ferrous and non-ferrous",
    "Glass wastes",
    "Paper and cardboard wastes",
    "Rubber wastes",
    "Plastic wastes",
    "Wood wastes",
    "Textile wastes",
    "Waste containing PCB",
    "Discarded equipment",
    "Discarded vehicles",
    "Batteries and accumulators wastes",
    "Animal and mixed food waste",
    "Vegetal wastes",
    "Slurry and manure",
    "Household and similar wastes",
    "Mixed and undifferentiated materials",
    "Sorting residues",
    "Common sludges",
    "Construction and demolition wastes",
    "Asbestos waste",
    "Waste of naturally occurring minerals",
    "Combustion wastes",
    "Various mineral wastes",
    "Soils",
    "Dredging spoil",
    "Waste from waste treatment",
    "Solidified, stabilised or vitrified waste"
  ];

  const location = useLocation();
  const { imageUrl, waste } = location.state || {};

  const initialValues = {
    wasteTypes: Array(waste.cropped_paths.length).fill('')
  };

  const handleSubmit = (values) => {
    console.log('Selected waste types:', values);
    PendingApprovalAPI.edit_waste_label(waste._id, JSON.stringify(values))
      .then((res) => {
        // navigate('/dashboard');
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div className="main-container">
      <Toolbar />
      <Sidebar />
      <div className="content-container">
        <div className="main-content">
          <div className="management-header">
            <h3>Pending Approval</h3>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', margin: '30px 0px' }}>
            <AnnotatedImage imageUrl={imageUrl} annotations={waste.annotations.annotations} />
          </div>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
          >
            {({ values, setFieldValue, submitForm }) => (
              <Form>
                <div className='manage-roles'>
                  <span>Image</span>
                  <span>Object</span>
                  <span>Score</span>
                  <span>Action</span>
                </div>
                {waste.cropped_paths.map((cropped_path, index) => (
                  <div className='manage-roles' key={index}>
                    <span>
                      <ImageComponent cropped_path={cropped_path} index={index} />
                    </span>
                    <span>
                      {wasteTypes.includes(values.wasteTypes[index]) ? (
                        <span>{values.wasteTypes[index]}</span>
                      ) : (
                        <span>
                          {waste.annotations.annotations[index]?.label ? (
                            waste.annotations.annotations[index].label
                          ) : 'N/A'}
                        </span>
                      )}
                    </span>
                    <span> N/A </span>
                    <FormSelect
                      name={`wasteTypes[${index}]`}
                      options={wasteTypes}
                      style={{ margin: '0px', width: '125px' }}
                      onChange={(e) => {
                        const selectedWasteType = e.target.value;
                        setFieldValue(`wasteTypes[${index}]`, selectedWasteType);
                        submitForm();
                      }}
                    />
                  </div>
                ))}
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default PendingApprovalView;
